import script from "./ClientIconsBeforeName.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientIconsBeforeName.vue?vue&type=script&lang=ts&setup=true"

import "./ClientIconsBeforeName.vue?vue&type=style&index=0&id=91a3f682&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a3f682"]])

export default __exports__